import Logo from "@/components/Logo";
import { Button } from "@/components/ui/Button";
import useStore from "@/store";
import Head from "next/head";
import Link from "next/link";
import ParagraphSection from "./components/ParagraphSection";
import { useTranslation } from "react-i18next";

const PrivacyPolicy = () => {
  const { t } = useTranslation("privacy-policy"); // ← NEW
  const isLoggedIn = useStore(state => state.isLoggedIn);

  return (
    <div className="flex flex-col gap-4 md:gap-6 p-4 md:p-6">
      <Head>
        <title>{t("page_title")}</title>
      </Head>

      <Link passHref href={isLoggedIn ? "/dashboard" : "/"}>
        <a className="mx-auto">
          <Logo />
        </a>
      </Link>

      <h1 className="text-2xl md:text-3xl text-center font-semibold">{t("main_title")}</h1>

      {/* 1 ▪ وصف الخدمة */}
      <ParagraphSection title={t("service_description_title")}>
        {t("service_description_body")}
      </ParagraphSection>

      {/* 2 ▪ جمع واستخدام البيانات */}
      <ParagraphSection title={t("data_collection_title")}>
        {t("data_collection_body")}
      </ParagraphSection>

      {/* 3 ▪ استخدام البيانات */}
      <ParagraphSection title={t("data_use_title")}>
        {t("data_use_body")}
      </ParagraphSection>

      {/* 4 ▪ مشاركة البيانات */}
      <ParagraphSection title={t("data_sharing_title")}>
        {t("data_sharing_body")}
      </ParagraphSection>

      {/* 5 ▪ الاحتفاظ بالبيانات */}
      <ParagraphSection title={t("data_retention_title")}>
        {t("data_retention_body")}
      </ParagraphSection>

      {/* 6 ▪ نقل البيانات */}
      <ParagraphSection title={t("data_transfer_title")}>
        {t("data_transfer_body")}
      </ParagraphSection>

      {/* 7 ▪ حذف البيانات */}
      <ParagraphSection title={t("data_deletion_title")}>
        {t("data_deletion_body")}
      </ParagraphSection>

      {/* 8 ▪ الكشف عن البيانات */}
      <ParagraphSection title={t("data_disclosure_title")}>
        {t("data_disclosure_body")}
      </ParagraphSection>

      {/* 9 ▪ أمان البيانات */}
      <ParagraphSection title={t("data_security_title")}>
        {t("data_security_body")}
      </ParagraphSection>

      {/* 10 ▪ تغييرات السياسة */}
      <ParagraphSection title={t("policy_changes_title")}>
        {t("policy_changes_body")}
      </ParagraphSection>

      {/* 11 ▪ معلومات الاتصال */}
      <div className="flex flex-col gap-2 items-center mx-auto mt-8 text-muted-foreground">
        <span>{t("contact_text")}</span>
        <Link passHref href="mailto:support@digital-home.org">
          <Button className="py-0 h-fit" variant="link">
            support@digital-home.org
          </Button>
        </Link>
        <Link passHref href="tel:0665044458">
          <Button className="py-0 h-fit" variant="link">
            0665044458
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
